import { render, staticRenderFns } from "./PostTitle.vue?vue&type=template&id=065c7f3c&scoped=true"
import script from "./PostTitle.vue?vue&type=script&lang=js"
export * from "./PostTitle.vue?vue&type=script&lang=js"
import style0 from "./PostTitle.vue?vue&type=style&index=0&id=065c7f3c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065c7f3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('065c7f3c')) {
      api.createRecord('065c7f3c', component.options)
    } else {
      api.reload('065c7f3c', component.options)
    }
    module.hot.accept("./PostTitle.vue?vue&type=template&id=065c7f3c&scoped=true", function () {
      api.rerender('065c7f3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sales/salesReps/component/PostTitle.vue"
export default component.exports